var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('providers',{attrs:{"album-i-d":_vm.album.album_id,"write-permission":_vm.album.is_admin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }